<template>
	<div>
		<el-form ref="digitalAncillariesSettings" :model="digitalAncillariesSettings" label-position="top">
			<el-row class="mb-2" :gutter="20">
				<el-col :span="24">
					<h3 class="mb-3">Digital Ancillaries Intro Text</h3>
					<el-form-item>
						<editor v-model="digitalAncillariesSettings.introText" :api-key="apiKey" :init="init"></editor>
					</el-form-item>
				</el-col>
				<el-col :span="24">
					<h3 class="mb-3">Digital Ancillaries Request Document Message</h3>
					<el-form-item>
						<editor v-model="digitalAncillariesSettings.requestedDocumentationText" :api-key="apiKey" :init="init"></editor>
					</el-form-item>
				</el-col>
				<el-col :span="24">
					<h3 class="mb-3">Digital Ancillaries Completion Text</h3>
					<el-form-item>
						<editor v-model="digitalAncillariesSettings.completionText" :api-key="apiKey" :init="init"></editor>
					</el-form-item>
				</el-col>
			</el-row>
            <el-button :disabled="saving" @click="saveSettings" type="primary">Save Settings</el-button>
		</el-form>
	</div>
</template>

<script>
	import Editor from "@tinymce/tinymce-vue"

	export default {
		name: "DigitalAncillariesSettings",
        components: {
            Editor
        },
		props: {
			introText: {
				required: true,
			},
			requestedDocumentationText: {
				required: true,
			},
			completionText: {
				required: true,
			},
		},
		data() {
			return {
				digitalAncillariesSettings: {},
                saving: false,
                init: {
					height: 400,
					menubar: false,
					plugins: [
						"advlist autolink link image lists charmap print preview hr pagebreak",
						"searchreplace wordcount code fullscreen insertdatetime media nonbreaking",
						"table directionality emoticons template paste",
					],
					noneditable_editable_class: "noneditable",
					visual: false,
					auto_focus: false,
					relative_urls: false,
					remove_script_host: false,
					toolbar:
						"undo redo | formatselect | bold italic forecolor backcolor fontsizeselect | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat",
				},
			}
		},

        computed: {
            apiKey() {
                return process.env.MIX_TINY_MCE_API
            },
        },

		watch: {
			introText: {
				handler() {
					Vue.set(this.digitalAncillariesSettings, "introText", this.introText)
				},
				immediate: true,
				deep: true,
			},
			requestedDocumentationText: {
				handler() {
					Vue.set(this.digitalAncillariesSettings, "requestedDocumentationText", this.requestedDocumentationText)
				},
				immediate: true,
				deep: true,
			},
			completionText: {
				handler() {
					Vue.set(this.digitalAncillariesSettings, "completionText", this.completionText)
				},
				immediate: true,
				deep: true,
			},
		},

		mounted() {},

		methods: {
            saveSettings() {
                this.saving = true
                axios.post('/admin/settings/digital-ancillaries', this.digitalAncillariesSettings)
                .then(res => {
                    this.saving = false
                    this.$message('Settings Saved.')
                })
                .catch(err => {
                    console.error(err);
                })
            }
        },
	}
</script>

<style lang="scss">
	.tox-tinymce {
		.tox-statusbar__branding {
			display: none !important;
		}
	}

	.tox-tinymce-aux {
		z-index: 9999999999 !important;
		.tox-notifications-container {
			display: none !important;
		}
	}
</style>
